const React = require('react');
const changeProviderProvider = require('mn-utils/changeProviderProvider');

const map = require('mn-utils/map');
const trim = require('mn-utils/trim');
const isASCII = require('mn-utils/isASCII');

const AddCircleOutlineIcon = require('@material-ui/icons/AddCircleOutline').default;
const DeleteIcon = require('@material-ui/icons/Delete').default;

const withState = require('../../../../../utils/withState');
const TextField = require('../../../../dumb/TextField/I');
const Button = require('../../../../dumb/Button/C');
const ButtonAccept = require('../../../../dumb/Button/Accept');
const {openPopupInfo} = require('../../../../../emitters/popup');
const validateUrlWithHttps = require('../../../../../utils/validateUrlWithHttps');
const {PAYMENT_METHODS_LIST} = require("../../../../../constants/paymentMethods");
const CheckboxD = require("../../../../dumb/Checkbox/D");

module.exports = withState((setState, self, onMount) => {
  const prevData = (self.props.defaultData || {});

  self.state = {
    ...prevData,
    loading: true,
  };
  let _lastId = 0;
  const changeProvider = changeProviderProvider(setState);

  return (state, props) => {
    const saveData = props.request;

    const appId = props.appId || '';

    const clicked = state.clicked;
    const appName = state.name || '';
    const callbackUrl = state.callbackUrl || '';
    const criticalCallbacksUrl = state.criticalCallbacksUrl || '';
    const headers = state.headers || [];
    const disabledMethods = state.disabled_methods || [];

    const invalidName = !appName || !validateUrlWithHttps(appName);
    const invalidCallbackUrl = !callbackUrl || !validateUrlWithHttps(callbackUrl);
    const invalidCritCallbackUrl = !criticalCallbacksUrl || !validateUrlWithHttps(criticalCallbacksUrl);
    const invalidDisabledMethods = disabledMethods.length === PAYMENT_METHODS_LIST.length;

    const headerIsValid = (value) => {
      const _value = trim(value);
      return _value && isASCII(_value);
    }

    const headerError = headers.some((el) => !headerIsValid(el.name) || !headerIsValid(el.value));

    const disabled = invalidName || invalidCallbackUrl || invalidDisabledMethods || headerError;

    return (
      <div className={'wmin270 ' + (props.className || '')}>
        <div className="mt30">
          <TextField
            label="App URL (only https) *"
            error={clicked && appName && invalidName}
            value={appName}
            onChange={changeProvider('name')}
            helperText={invalidName ? 'Wrong url format' : ''}
          />
        </div>
        <div className="mt30">
          <TextField
            label="Callback URL (only https) *"
            error={clicked && callbackUrl && invalidCallbackUrl}
            value={callbackUrl}
            onChange={changeProvider('callbackUrl')}
            helperText={invalidCallbackUrl ? 'Wrong url format' : ''}
          />
        </div>
        <div className="mt30">
          <TextField
            label="Critical callback URL (only https)"
            error={clicked && invalidCritCallbackUrl}
            value={criticalCallbacksUrl}
            onChange={changeProvider('criticalCallbacksUrl ')}
            helperText={invalidCritCallbackUrl ? 'Wrong url format' : ''}
          />
        </div>
        <div className="f15 fw5 mt35">Headers</div>
        <div className="mt10">
          {map(headers, (header, i) => {
            const {
              name,
              value,
            } = header;

            const changeChildProvider = changeProviderProvider((next) => {
              const _headers = [...headers];
              _headers[i] = {
                ...header,
                ...next,
              };
              setState({
                headers: _headers,
              });
            });

            const invalidName = !headerIsValid(name);
            const invalidValue = !headerIsValid(value);

            return (
              <div
                key={header.id || header._id}
                className="layoutRow fhaS fvaC bs bcF2 b bt1
                        (bt|pt):first pb:last pv10"
              >
                <div className="layoutRow fhaS fvaC w1/2>1 fx1">
                  <div>
                    <TextField
                      label="Name"
                      value={name}
                      onChange={changeChildProvider('name')}
                      error={clicked && invalidName}
                      helperText={name && invalidName ? 'Must be ASCII characters' : ''}
                    />
                  </div>
                  <div className="pl10">
                    <TextField
                      label="Value"
                      value={value}
                      onChange={changeChildProvider('value')}
                      error={clicked && invalidValue}
                      helperText={value && invalidValue ? 'Must be ASCII characters' : ''}
                    />
                  </div>
                </div>
                <div className="pl10">
                  <Button
                    onClick={() => {
                      const _headers = [...headers];
                      _headers.splice(i, 1);
                      setState({
                        headers: _headers,
                      });
                    }}
                  >
                    <DeleteIcon/>
                  </Button>
                </div>
              </div>
            );
          }, [])}
        </div>
        <div className="mt20">
          <Button
            onClick={() => {
              setState({
                headers: [
                  ...headers,
                  {
                    _id: ++_lastId,
                    name: '',
                    value: '',
                  },
                ],
              });
            }}
          >
            <AddCircleOutlineIcon/>
            <div className="pl10">Add</div>
          </Button>
        </div>
        {/*<div className="layoutRow jcSB aiC mt35">*/}
        {/*  <div className="f15 fw5">Disable payment methods</div>*/}
        {/*  {invalidDisabledMethods && (*/}
        {/*    <span className="cF00">*/}
        {/*      There must be at least one payment method enabled*/}
        {/*    </span>*/}
        {/*  )}*/}
        {/*</div>*/}
        {/*<div className="mt30">*/}
        {/*  {paymentMethods.map((el) => {*/}
        {/*    const isActive = disabledMethods.includes(el.id);*/}

        {/*    const onClick = () => {*/}
        {/*      let _disabledMethods = [...disabledMethods];*/}

        {/*      if (isActive) {*/}
        {/*        _disabledMethods = _disabledMethods.filter((id) => id !== el.id);*/}
        {/*      } else {*/}
        {/*        _disabledMethods.push(el.id)*/}
        {/*      }*/}

        {/*      setState({*/}
        {/*        disabled_methods: _disabledMethods,*/}
        {/*      });*/}
        {/*    };*/}

        {/*    return (*/}
        {/*      <CheckboxD*/}
        {/*        key={el.id}*/}
        {/*        className="mt10"*/}
        {/*        label={(<>*/}
        {/*          {el.name}*/}
        {/*        </>)}*/}
        {/*        checked={isActive}*/}
        {/*        onChange={onClick}*/}
        {/*        // error={invalidAccept && clicked}*/}
        {/*      />*/}
        {/*    )*/}
        {/*  })}*/}
        {/*</div>*/}
        <div className="mt50 layoutRow fhaB fvaC">
          <ButtonAccept
            disabled={clicked && disabled}
            onClick={() => {
              if (disabled) {
                setState({
                  clicked: true,
                });
                return;
              }
              setState({
                loading: true,
              });

              const data = {
                name: appName,
                callback_address: callbackUrl,
                disabled_methods: disabledMethods,
                critical_callbacks_enabled: !!criticalCallbacksUrl,
                critical_callbacks_address : criticalCallbacksUrl,
                headers: (headers || []).length
                  ? map(headers, (header) => {
                    const {name, value} = header;
                    return [name, value];
                  }) : [],
              };

              if (appId) data['app_id'] = appId;

              saveData(data, state.prev).finally((error) => {
                if (error) return;

                openPopupInfo(props.resultText);
              });
            }}
          >Save changes</ButtonAccept>
        </div>
      </div>
    );
  };
});
